<mat-sidenav-container fxFlexFill>
  <mat-sidenav [mode]="mode">
    <mat-nav-list>
      <ng-container *ngFor="let item of menuItems">
        <ng-container *ngIf="item.visible && subItemsVisible(item)">
          <a mat-list-item (click)="onSelectItem(item)">
            {{ item.label | translate }}
            <mat-icon class="expand-icon">{{ item === selectedItem ? 'expand_less' : 'expand_more' }}</mat-icon>
          </a>

          <ng-container *ngIf="item === selectedItem">
            <ng-container *ngFor="let item of item.subTabs">
              <a
                mat-list-item
                class="sub-item"
                *ngIf="item.visible"
                [routerLink]="item.path"
                routerLinkActive="mat-item--active"
                #rla="routerLinkActive"
                [routerLinkActiveOptions]="{ exact: true }"
                [active]="rla.isActive"
                (click)="sidenav.close()"
              >
                {{ item.label | translate }}
              </a>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
      <hr [fxHide.gt-md]="true" class="mat-list-divider" />
      <div class="company-name">
        <mat-icon class="icon material-icons-outlined">home</mat-icon>
        <span class="value">{{ customer?.companyName }}</span>
      </div>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content fxFlexFill>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
